import getUserAgent from '@/methods/getUserAgent'

const UserAgent = getUserAgent()

export const hideDownloadButton = () =>
  UserAgent.system === 'ios' &&
  (UserAgent.browser === 'opera' || UserAgent.browser === 'firefox')
